import parse from 'html-react-parser'

// Returns the markup for the details tab when editing a course
export default function CourseDetails({ course }) {
    return (
        <>
            <div className='course-details-images'>
                {course.media?.primary_image?.startsWith('http') && (
                    <a className='course-details-image' href={course.media?.primary_image} target='_blank'>
                        <img src={course.media?.primary_image} />
                    </a>
                )}

                {course.media?.images?.filter((image) => image?.startsWith('http')).slice(0, 8).map((image, index) => (
                    <a key={image} className='course-details-image' href={image} target='_blank'>
                        <img key={index} src={image} />
                    </a>
                ))}
            </div>

            <div className='course-details-text'>
                {parse(course?.description, { replace: (domNode) => {
                    if (domNode.attribs && domNode.attribs.href) {
                        return <a href={`https://www.golfholidaysdirect.com${domNode.attribs.href}`} target='_blank'>{domNode.children[0].data}</a>
                    }
                } })}
            </div>
        </>
    )
}
